// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__SsTxb","blockMsg":"Message_blockMsg__hOeED","avatar":"Message_avatar__86gzM","avatarBg":"Message_avatarBg__ZFrow","nameAuthor":"Message_nameAuthor__MUk2w"};